import Account from '@/helper/AccountHelper.js';
import ConfigManager from '@/config/ConfigManager.js'
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';
import { InsuranceModel } from '../model/InsuranceModel';

export default {
    /**
     * @param {ProfileModel} profile /core/Account/model/AccountModel.js
     * @returns
     */
    getInsurance: function (profile) {
        let params = {
            idcard: profile?.nationalIdCard,
            firstname: profile?.firstName || '',
            lastname: profile?.lastName || '',
        };
        let token = Account.getToken();
        let url = ConfigManager.getApiModuleUrl() + '/user/getpolicydetail';
        return BzbsApi.connectBzbsGet(url, token, params).pipe(map((res) => {
            let list = [];
            let data = res.data?.data?.PolicyInsurances;
            for (let i of data) {
                let insurance = new InsuranceModel();
                insurance.setDataFromApi(i);
                list.push(insurance);
            }
            return list;
        }));
    },
}
